import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import UnstyledCollectionList from '../components/CollectionList';
import Table from '../components/Table';
import dataStore from '../models/dataStore';
import useCollectionItems from '../utils/useCollectionItems';
const Wrapper = styled.div `
  display: grid;
  grid-template-areas: 'list items';
  grid-template-columns: 200px 1fr;
  overflow: hidden;
  height: 100%;
`;
const CollectionList = styled(UnstyledCollectionList) `
  grid-area: list;
`;
const Items = styled(Table) `
  grid-area: items;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
const Data = () => {
    const [collectionName, setCollectionName] = useState();
    const collectionsItem = dataStore.useItem('collections');
    const collection = useMemo(() => collectionsItem?.items.find(c => c.name === collectionName), [collectionsItem, collectionName]);
    const collectionItems = useCollectionItems(collectionName || '');
    return (_jsxs(Wrapper, { children: [_jsx(CollectionList, { value: collectionName, onChange: name => setCollectionName(name) }), collection
                ? (_jsx(Items, { itemColumn: `${collectionName} (${collectionItems.length} items)`, items: collectionItems, onAdd: item => collection.insert(item), onEdit: (id, item) => collection.updateOne({ id }, { $set: item }), onRemove: id => collection.removeOne({ id }) }))
                : (_jsx(Items, { items: [], columns: [], placeholder: "Select a collection on the left" }))] }));
};
export default Data;
